import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource } from '@angular/material';
import { DocentesDependenciaUaaDto } from 'src/app/dto/docentes-dependencia-uaa-dto';
import { EvadocEvaluadorDto } from 'src/app/dto/evadoc-evaluador-dto';
import { DocenteService } from 'src/app/services/docente.service';
import { EvaluarDocentexDocenteService } from 'src/app/services/evaluar-docentex-docente.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pares-dialog',
  templateUrl: './pares-dialog.component.html',
  styleUrls: ['./pares-dialog.component.css']
})
export class ParesDialogComponent implements OnInit {

  displayedColumnsE: string[] = ['check', 'identificacion', 'docente'];
  seleccion: DocentesDependenciaUaaDto;
  public load: boolean;
  form: FormGroup;
  DocentesPar: DocentesDependenciaUaaDto[];
  datasourseE = new MatTableDataSource<DocentesDependenciaUaaDto>([]);
  correoEvaluador: any;
  isSubmitting: boolean = false;

  constructor(
    private docenteService: DocenteService,
    private fb: FormBuilder,
    private evaluarDocenteService: EvaluarDocentexDocenteService,
    public dialogRef: MatDialogRef<ParesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { this.load = false; }

  ngOnInit(): void {
    this.adjustDialogSize();
    this.load = true;
    this.InitForm();
  }

  private adjustDialogSize() {
    const width = window.innerWidth;
    if (width < 576) {
      this.dialogRef.updateSize('100vw', '100vh');
    } else if (width < 992) {
      this.dialogRef.updateSize('90%', 'auto');
    } else {
      this.dialogRef.updateSize('600px', 'auto');
    }
  }

  InitForm() {
    this.form = this.fb.group({
      identificacion: new FormControl('', [
        Validators.required,
        Validators.pattern('^([A-Za-z][0-9]{5,9}|[0-9]{6,10})$'), // Una letra + números (6-10) o solo números (6-10)
        Validators.minLength(6),
        Validators.maxLength(10)
      ])
    })
  }

  docenteporIdentificacion() {
    this.load = false;
    this.docenteService.obtenerParIdentificacion(this.form.value.identificacion).subscribe(data => {
      if (data.length > 0) {
        this.DocentesPar = data;
        this.DocentesPar.map((item: any) => {
          this.correoEvaluador = item.correo;
        })
        this.load = true;
        this.datasourseE = new MatTableDataSource<DocentesDependenciaUaaDto>(this.DocentesPar);
      } else {
        this.load = true;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: '!Docente no encontrado!'
        })
      }
    })
  }

  RegistrarEvaluado(element: any) {
    if (this.isSubmitting) return;

    if (this.data.accion === 'Editar' && this.data.docente.evaluador) {
      const codigoActual = this.data.docente.evaluador.persona.codigo;
      if (element.codigoPersona === codigoActual) {
        Swal.fire({
          icon: 'info',
          title: '¡Mismo evaluador!',
          text: 'El docente seleccionado ya es el par evaluador asignado. Seleccione uno diferente.',
          confirmButtonColor: '#8F141B',
          confirmButtonText: 'Entendido'
        });
        return;
      }
    }

    let evadocEvaluadorDto: EvadocEvaluadorDto = new EvadocEvaluadorDto();
    evadocEvaluadorDto.docente = this.data.evaluado;
    evadocEvaluadorDto.evaluador = element.codigoPersona;
    evadocEvaluadorDto.periodo = this.data.periodoEvaluacion;

    this.isSubmitting = true;

    if (this.data.accion == 'Agregar') {
      this.evaluarDocenteService.GuardarEvaluador(evadocEvaluadorDto).subscribe(data => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: '¡Evaluador Registrado!',
          showConfirmButton: false,
          timer: 1500
        })
        this.dialogRef.close(this.correoEvaluador);
      },
        error => {
          this.isSubmitting = false;
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Transacción no realizada.',
            showConfirmButton: false,
            timer: 1500
          })
          this.dialogRef.close(this.correoEvaluador);
        }
      )
    } else if (this.data.accion == 'Editar') {
      this.evaluarDocenteService.actualizar(evadocEvaluadorDto).subscribe(data => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: '¡Evaluador Actualizado!',
          showConfirmButton: false,
          timer: 1500
        })
        this.dialogRef.close(this.correoEvaluador);
      },
        error => {
          this.isSubmitting = false;
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Transacción no realizada.',
            showConfirmButton: false,
            timer: 1500
          })
          this.dialogRef.close(this.correoEvaluador);
        }
      )
    }
  }
}
